"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var getActionProps = function getActionProps(action, theme) {
  switch (action) {
    case 'primary':
      {
        return {
          color: theme.primary.color
        };
      }

    default:
      return {
        color: theme.secondary.color
      };
  }
};

var StyledLink = styled_components_1.default.a(function (props) {
  var _a = props.action,
      action = _a === void 0 ? 'secondary' : _a,
      theme = props.theme;
  var actionProps = getActionProps(action, theme.components.link);
  return __assign(__assign({}, actionProps), {
    textDecoration: 'none',
    fontFamily: theme.fontText,
    cursor: 'pointer'
  });
});
exports.default = StyledLink;